import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import HeadCont from "../../components/common/HeadCont";
import PersonalInfo from "../../components/account/PersonalInfo";
import TermsOfService from "../../components/account/TermsOfService";
import HealthInfoPolicy from "../../components/account/HealthInfoPolicy";
import TabCommon from "../../components/common/TabCommon";

const Policy = () => {
  const { t } = useTranslation('settings');
  const location = useLocation();
  const navigate = useNavigate();
  const initialTab = location.state?.tab || t('legal.privacy_policy');
  const returnTo = location.state?.returnTo;
  const [tab, setTab] = useState(initialTab);
  const tabs = [t('legal.privacy_policy'), t('legal.terms_of_service'), t('legal.health_info_policy')];
  // const onCloseMenu = () => {

  //   let menu = document.querySelector("#menu")
  //   menu.scrollTo(0, 0)
  // }

  const handleBack = () => {
    if (returnTo) {
      navigate(returnTo);
    } else {
      navigate(-1);
    }
  };

  return (
    <>
      <HeadCont
        title={t('legal.terms_and_policy')}
        onLeftAction={handleBack}
      />
      <section className="mt-14">
        <TabCommon tabs={tabs} setTab={setTab} tab={tab} />
        <div className="p-4">
          {tab === t('legal.privacy_policy') ? <PersonalInfo /> :
           tab === t('legal.terms_of_service') ? <TermsOfService /> :
           <HealthInfoPolicy />}
        </div>
      </section>
    </>
  );
};

export default Policy;
